import WithNoAuthorization from './WithNoAuthorization';

export default WithNoAuthorization;
